import type { App } from 'vue'
import type { Locale } from '@/settings/langs'
import axios from 'axios'
import { skipMaintenance } from '@/components/layout/Maintenance/Maintenance.ts'
import { i18nLocale, spaI18n } from '@/compositions/i18nPlugin'
import { localeToOgLocale } from '@/settings/langs'

export default {
  install: (Vue: App) => {
    const instance = axios.create()
    instance.interceptors.request.use(
      (config) => {
        config.headers['Accept-Language'] = (localeToOgLocale[i18nLocale.value as Locale] ?? i18nLocale.value).replace('_', '-')
        if (skipMaintenance.value === true) {
          const tokenMaintenance: string = import.meta.env.VITE_MAINTENANCE_TOKEN || ''
          if (tokenMaintenance) {
            // config.headers.Maintenance = tokenMaintenance
          }
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    instance.interceptors.response.use(
      response => response,
      (error) => {
        if (error?.response?.status === 401) {
          return Promise.reject(error)
        } else if (error?.response?.status > 400) {
          Vue.config.globalProperties.$notify({
            title: spaI18n.global.t('gamesUtils.error'),
            type: 'warning',
            customClass: 'child-inherit-colors text-red-600 z-999999',
            message: error?.response?.data?.msg || spaI18n.global.t('gamesUtils.oopsSomethingWentWrong'),
            duration: 9000
          })
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject(false)
        }
        return Promise.reject(error)
      }
    )
    Vue.config.globalProperties.$axios = instance
  }
}
